module.exports = __webpack_public_path__ + "img/estimates.5b907e63.svg";